import { Instagram, Mail, Calendar, MessageCircle, Linkedin } from "lucide-react";
import { site } from "../../lib/siteConfig";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-brand-ink text-white/85">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-16 sm:py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="font-display text-3xl text-white">
              Gorla<span className="italic font-normal"> Properties</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/60 max-w-sm">
              Consulenza strategica sulla rendita immobiliare da locazione — Milano e le principali città italiane.
            </p>
            <div className="mt-6 space-y-1 text-xs text-white/45">
              <div data-testid="footer-rea">{site.rea}</div>
              <div data-testid="footer-vat">{site.vat}</div>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-brand-beige font-semibold">Navigazione</div>
            <ul className="mt-5 space-y-2.5 text-sm">
              <li><a href="#chi-sono" className="hover:text-white transition-colors" data-testid="footer-link-chi-sono">Chi sono</a></li>
              <li><a href="#servizi" className="hover:text-white transition-colors" data-testid="footer-link-servizi">Servizi</a></li>
              <li><a href="#portfolio" className="hover:text-white transition-colors" data-testid="footer-link-portfolio">Portfolio</a></li>
              <li><a href="#dove-lavoro" className="hover:text-white transition-colors" data-testid="footer-link-dove-lavoro">Dove lavoro</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-brand-beige font-semibold">Contatti</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a
                  href={`mailto:${site.email}`}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Mail size={14} />
                  {site.email}
                </a>
              </li>
              <li>
                <a
                  href={site.whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <MessageCircle size={14} />
                  WhatsApp · {site.whatsappNumber}
                </a>
              </li>
              <li>
                <a
                  href={site.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Instagram size={14} />
                  {site.instagramHandle}
                </a>
              </li>
              <li>
                <a
                  href={site.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Linkedin size={14} />
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href={site.calendly}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-calendly"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Calendar size={14} />
                  Prenota una call
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-white/45">
            © {new Date().getFullYear()} Gorla Properties · Francesca Gorla · Tutti i diritti riservati
          </div>
          <div className="text-xs text-white/45 uppercase tracking-[0.22em]">
            Milano · Italia
          </div>
        </div>
      </div>
    </footer>
  );
};
